export enum OptionsSeatControlNames {
  Weight = 'weight',
  VolumetricLength = 'volumetricLength',
  VolumetricWidth = 'volumetricWidth',
  VolumetricHeight = 'volumetricHeight',
  VolumetricVolume = 'volumetricVolume',
  PackRef = 'packRef',
  SpecialCargo = 'specialCargo',
  Cost = 'cost',
}
